import type { RouteRecordRaw } from "vue-router";

import { CompletionRoutes, TestCompletionRoutes } from "../enums/routes/CompletionRoutes";
import BetaCompletionLayout from "../layout/app/beta/CompletionLayout.vue";
import CompletionLayout from "../layout/app/production/CompletionLayout.vue";

export function completionRoutes(): RouteRecordRaw[] {
    return [
        {
            path: "/completion",
            component: CompletionLayout,
            children: [
                {
                    path: "/completion",
                    name: CompletionRoutes.IDLE,
                    component: () => import("../views/apps/completion/CompletionIdleView.vue"),
                },
                {
                    path: "/completion/signin",
                    name: CompletionRoutes.SIGNIN,
                    component: () => import("../views/apps/completion/CompletionSignInView.vue"),
                },
                {
                    path: "/completion/load",
                    name: CompletionRoutes.LOAD_CONTAINER,
                    component: () => import("../views/apps/completion/CompletionLoadContainerView.vue"),
                },
                {
                    path: "/completion/settings",
                    name: CompletionRoutes.SETTINGS,
                    component: () => import("../views/apps/completion/CompletionUserSettingsView.vue"),
                },
                {
                    path: "/completion/container/:code",
                    name: CompletionRoutes.CONTAINER_VIEW,
                    component: () => import("../views/apps/completion/CompletionContainerView.vue"),
                },
            ],
        },
        {
            path: "/test/completion",
            component: BetaCompletionLayout,
            children: [
                {
                    path: "/test/completion",
                    name: TestCompletionRoutes.IDLE,
                    component: () => import("../views/apps/test/completion/CompletionIdleView.vue"),
                },
                {
                    path: "/test/completion/signin",
                    name: TestCompletionRoutes.SIGNIN,
                    component: () => import("../views/apps/test/completion/CompletionSignInView.vue"),
                },
                {
                    path: "/test/completion/load",
                    name: TestCompletionRoutes.LOAD_CONTAINER,
                    component: () => import("../views/apps/test/completion/CompletionLoadContainerView.vue"),
                },
                {
                    path: "/test/completion/settings",
                    name: TestCompletionRoutes.SETTINGS,
                    component: () => import("../views/apps/test/completion/CompletionUserSettingsView.vue"),
                },
                {
                    path: "/test/completion/container/:code",
                    name: TestCompletionRoutes.CONTAINER_VIEW,
                    component: () => import("../views/apps/test/completion/CompletionContainerView.vue"),
                },
            ],
        },
    ];
}
